import CustomAigcImage from '@/material/AigcImageComponent/info/custom/customImage';
import CustomAigcModel from '@/material/AigcImageComponent/info/custom/customModel';
import CustomAigcNumber from '@/material/AigcImageComponent/info/custom/customNumber';
import CustomAigcRatio from '@/material/AigcImageComponent/info/custom/customRatio';
import CustomAigcFrame from '@/material/AigcVideoComponent/info/custom/customFrame';
import CustomUpload from '@/material/form-upload/customUpload';
import { baseRender, customRender } from '@/material/render';
import { CustomArrayField } from '@/pages/bot/info/custom-form/customField';
import { CustomModelSelect } from '@/pages/bot/info/custom-form/customModelSelect';
import { CustomPhase1 } from '@/pages/bot/info/custom-form/customPhase1';
import { CustomPhase2 } from '@/pages/bot/info/custom-form/customPhase2';
import { CustomPhaseSelector } from '@/pages/bot/info/custom-form/customPhaseSelector';
import { CustomArrayQA } from '@/pages/bot/info/custom-form/customQA';
import { CustomRelationshipComponent } from '@/pages/bot/info/custom-form/customRelationship';
import { CustomArrayReplaceMsg } from '@/pages/bot/info/custom-form/customReplaceMsg';
import { CustomSchedule } from '@/pages/bot/info/custom-form/customSchedule';
import { CustomScoreRules } from '@/pages/bot/info/custom-form/customScoleRules';
import { CustomUploadSelect } from '@/pages/bot/info/custom-form/customUploadSelect';
import { CustomVoiceSelect } from '@/pages/bot/info/custom-form/customVoiceSelect';
import CountDown from '@/pages/gamePlay/countDown';
import NumSys from '@/pages/gamePlay/numSys';
import { SwitchGroup } from '@/pages/gamePlay/switchGroups';
import CustomBranch from '@/pages/mission/info/card/event/customBranch';
import { CustomArrayEvents } from '@/pages/mission/info/card/event/customEvent';
import CustomMissionGoal from '@/pages/mission/info/card/event/customGoal';
import { CustomNovelHomeIndex } from '@/pages/novel/home/info/custom-index';
import CustomNovelMultiCollection from '@/pages/novel/home/info/custom-index/list/customMultiCollection';
import CustomNovelSelect from '@/pages/novel/home/info/custom-index/list/customNovelSearch';
import { CustomPlazaIndex } from '@/pages/plaza/info/custom-form/custom-plaza-index';
import { CustomStoryComponent } from '@/pages/promotion/info/custom-form';
import { CustomBotComponent } from '@/pages/promotion/info/custom-form/custom-bot';
import { CustomPromotionIndex } from '@/pages/promotion/info/custom-form/custom-index';
import CustomMultiCollection from '@/pages/promotion/info/custom-form/custom-index/list/customMultiCollection';
import CustomOfficialActivity from '@/pages/promotion/info/custom-form/custom-index/list/officialActivity';
import CustomLabel from '@/pages/promotion/info/custom-form/custom-story/list/custom-label';
import { FinalSwitch } from '@/pages/scene/info/custom-form/finalSwitch';
import { SceneBots } from '@/pages/scene/info/custom-form/sceneBots';
import { CustomPlayInfo } from '@/pages/story/info/custom-form';
import CustomDub from '@/pages/story/info/custom-form/custom-dub';
import CustomRadio from '@/pages/story/info/custom-form/custom-radio';

import { ChatTextComponent } from './ChatText';
import { ColorSelect } from './ColorSelect';
import { DebounceSelect } from './DebounceSelect';
import { NovaDivider } from './Divider';
import { InputAdornmentComp } from './InputAdornment';
import { InstructionInputComponent } from './InstructionInput';
import KeyPointComponent from './KeyPointTimer';
import { Line } from './Line';
import { NumSwitch } from './NumSwitch';
import { RelationInput } from './RelationInput';
import { FormArrayComponent } from './Struct/formInputArray/form-array';
import TagChoose from './TagChoose';
import { TagInputComponent as TagInput } from './TagInput';
import { TextareaComponent } from './Textarea';
import { JsonTextareaComponent } from './Textarea/json';
import TextareaImage from './TextareaImage';
import TextareaPrompt from './TextareaPrompt';
import { TextareaSearch } from './TextareaSearch';
import { FormTitle } from './Title';
import VoicePlay from './VoicePlay';

export const renderFunMap: { [key: string]: any } = {
  tagInput: TagInput,
  instructionInput: InstructionInputComponent,
  textarea: TextareaComponent,
  jsonTextarea: JsonTextareaComponent,
  chatText: ChatTextComponent,
  divider: NovaDivider,
  inputAdornment: InputAdornmentComp,
  numSwitch: NumSwitch,

  debounceSelect: DebounceSelect,
  keyPointTimer: KeyPointComponent,
  color: ColorSelect,

  textSearch: TextareaSearch,
  relationInput: RelationInput,
  formTitle: FormTitle,
  inputArray: FormArrayComponent,
  line: Line,
  array: FormArrayComponent,
  bg: () => <div></div>,

  customPlayInfo: CustomPlayInfo,
  customArrayEvents: CustomArrayEvents,
  customArrayReplaceMsg: CustomArrayReplaceMsg,
  customUploadSelect: CustomUploadSelect,
  customVoiceSelect: CustomVoiceSelect,
  customModelSelect: CustomModelSelect,
  customSchedule: CustomSchedule,
  customArrayQA: CustomArrayQA,
  customArrayField: CustomArrayField,
  customPlazaIndex: CustomPlazaIndex,
  customRelationshipComponent: CustomRelationshipComponent,
  CustomUpload,
  CustomPhase1,
  CustomPhase2,
  CustomScoreRules,
  CustomPhaseSelector,
  CustomRadio,
  CustomDub,
  SceneBots,
  FinalSwitch,
  switchGroup: SwitchGroup,
  numSys: NumSys,
  countDown: CountDown,
  VoicePlay,

  // 亲密度
  customMissionGoal: CustomMissionGoal,

  // AIGC相关组件
  textareaPrompt: TextareaPrompt,
  textareaImage: TextareaImage,
  tagChoose: TagChoose,
  customAigcModel: CustomAigcModel,
  customAigcNumber: CustomAigcNumber,
  customAigcRatio: CustomAigcRatio,
  customAigcImage: CustomAigcImage,
  customAigcFrame: CustomAigcFrame,

  // manage
  customLabel: CustomLabel,
  customPromotionIndex: CustomPromotionIndex,
  customStories: CustomStoryComponent,
  customBots: CustomBotComponent,
  customMultiCollection: CustomMultiCollection,
  customNovelMultiCollection: CustomNovelMultiCollection,
  customNovelHomeIndex: CustomNovelHomeIndex,
  customNovelSelect: CustomNovelSelect,
  customBranch: CustomBranch,
  customOfficialActivity: CustomOfficialActivity,

  ...baseRender,
  ...customRender,
};
